import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import '../styles/NavMenu.css';

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.CloseNav = this.CloseNav.bind(this)
    this.state = {
      collapsed: true
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  CloseNav(){
    this.state({collapsed: !this.state.collapsed})
  }

  render () {
    return (
      <header>
        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-black border-bottom box-shadow">
          <Container>
            <h3 class='text-success'>3 P's</h3>
            <NavbarToggler onClick={this.toggleNavbar} className="mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="white" class="bi bi-list" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
              </svg>
            </NavbarToggler>
            <Collapse className="d-sm-inline-flex flex-sm-row-reverse bs-example-navbar-collapse-1" isOpen={!this.state.collapsed} navbar>
              <ul className="navbar-nav flex-grow">
                <NavItem>
                  <NavLink tag={Link} onClick={this.CloseNav} className="text-white" to="/">Home</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} onClick={this.CloseNav} className="text-white" to="/Team">Our Team</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} onClick={this.CloseNav} className="text-white" to="/Portfolio">Portfolio</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} onClick={this.CloseNav} className="text-white" to="/Services">Services</NavLink>
                </NavItem>
                {/* <NavItem>
                  <NavLink tag={Link} className="text-white" to="/Testinomials">Testinomials</NavLink>
                </NavItem> */}
                <NavItem>
                  <NavLink tag={Link} onClick={this.CloseNav} className="text-white" to="/About">About Us</NavLink>
                </NavItem>
              </ul>
            </Collapse>
          </Container>
        </Navbar>
      </header>
    );
  }
}
